export default "__VITE_ASSET__f742ef4d__"